import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=c0b3cca6"
import script from "./RecordItem.vue?vue&type=script&lang=js"
export * from "./RecordItem.vue?vue&type=script&lang=js"
import style0 from "./RecordItem.vue?vue&type=style&index=0&id=c0b3cca6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports